import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = match[1];

    (async () => {
      try {
        const { data } = await api.post(
          "/auth/google/session",
          {},
          { headers: { "X-Session-ID": sessionId } }
        );
        setUser(data);
        // Clean the URL fragment
        const target =
          data?.role === "client" ? "/mein-bereich"
          : data?.role === "participant" ? "/weiterbildung/mein-bereich"
          : "/dashboard";
        window.history.replaceState(null, "", target);
        navigate(target, { replace: true });
      } catch (e) {
        console.error("Google session exchange failed", e);
        const detail = e?.response?.data?.detail;
        const msg = typeof detail === "string" ? detail : "";
        const params = new URLSearchParams();
        params.set("error", "google");
        if (msg) params.set("msg", msg);
        navigate(`/login?${params.toString()}`, { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="text-xs font-bold uppercase tracking-overline text-slate-500 mb-3">
          Anmeldung läuft
        </div>
        <div className="font-heading text-3xl text-slate-900 font-light tracking-tighter">
          Sitzung wird hergestellt…
        </div>
      </div>
    </div>
  );
}
